var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarfull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 115,
    viewBox: "0 0 75 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 115,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3916_412046)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1038,
    transform: "translate(-681 -774)",
    fill: "#F9FAFC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3916_412046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -377,
    y: -72,
    width: 1457,
    height: 318,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3916_412046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -354,
    width: 429,
    height: 222,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.326 22.9072H85.6545L69.0139 -26.3115L52.3733 22.9072H-1.29858L42.0608 53.376L25.4202 102.595L69.0139 72.126L112.373 102.595L95.7327 53.376L139.326 22.9072Z",
    fill: "#2C74D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.269 16.5786L111.644 -10.1401L87.0349 6.73487L90.5506 16.5786H102.269ZM59.3787 86.188L68.988 114.313L78.5974 86.188L68.988 79.6255L59.3787 86.188ZM112.816 49.3911L103.91 55.4849L107.66 66.7349H137.894L112.816 49.3911ZM50.9412 6.73487L26.3318 -10.1401L35.7068 16.5786H47.4255L50.9412 6.73487ZM25.1599 49.3911L0.0817871 66.7349H30.3162L34.0662 55.4849L25.1599 49.3911Z",
    fill: "#2C74D6"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -353,
    y: 1,
    width: 427,
    height: 220,
    rx: 7,
    stroke: "#EAECF0",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3916_412046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1038,
    fill: "white",
    transform: "translate(-681 -774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3916_412046"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -377,
    y: -72,
    width: 1457,
    height: 318,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3916_412046"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -354,
    width: 429,
    height: 222,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarfull);
export default "data:image/svg+xml,%3csvg width='75' height='115' viewBox='0 0 75 115' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect width='75' height='115' fill='%23F5F5F5'/%3e %3cg clip-path='url(%23clip0_3916_412046)'%3e %3crect width='1440' height='1038' transform='translate(-681 -774)' fill='%23F9FAFC'/%3e %3cg clip-path='url(%23clip1_3916_412046)'%3e %3crect x='-377' y='-72' width='1457' height='318' rx='8' fill='white'/%3e %3cg clip-path='url(%23clip2_3916_412046)'%3e %3crect x='-354' width='429' height='222' rx='8' fill='white'/%3e %3cg opacity='0.15'%3e %3cpath d='M139.326 22.9072H85.6545L69.0139 -26.3115L52.3733 22.9072H-1.29858L42.0608 53.376L25.4202 102.595L69.0139 72.126L112.373 102.595L95.7327 53.376L139.326 22.9072Z' fill='%232C74D6'/%3e %3cpath d='M102.269 16.5786L111.644 -10.1401L87.0349 6.73487L90.5506 16.5786H102.269ZM59.3787 86.188L68.988 114.313L78.5974 86.188L68.988 79.6255L59.3787 86.188ZM112.816 49.3911L103.91 55.4849L107.66 66.7349H137.894L112.816 49.3911ZM50.9412 6.73487L26.3318 -10.1401L35.7068 16.5786H47.4255L50.9412 6.73487ZM25.1599 49.3911L0.0817871 66.7349H30.3162L34.0662 55.4849L25.1599 49.3911Z' fill='%232C74D6'/%3e %3c/g%3e %3c/g%3e %3crect x='-353' y='1' width='427' height='220' rx='7' stroke='%23EAECF0' stroke-width='2'/%3e %3c/g%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0_3916_412046'%3e %3crect width='1440' height='1038' fill='white' transform='translate(-681 -774)'/%3e %3c/clipPath%3e %3cclipPath id='clip1_3916_412046'%3e %3crect x='-377' y='-72' width='1457' height='318' rx='8' fill='white'/%3e %3c/clipPath%3e %3cclipPath id='clip2_3916_412046'%3e %3crect x='-354' width='429' height='222' rx='8' fill='white'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };